import React, { Component } from "react";
import { Input } from "reactstrap";
import Cookies from "js-cookie";
export class AutoComplete extends Component {
  constructor(props) {
    super(props);
    this.wrapperRef = React.createRef();
    this.state = {
      activeSuggestion: 0,
      filteredSuggestions: [],
      showSuggestions: false,
      userInput: "",
    };
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }
  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }
  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
      this.setState({
        showSuggestions : false 
      })
    }
  }

  handleChange = (e) => {
    const { data } = this.props;
    const userInput = e.currentTarget.value;

    const filteredSuggestions =
      data &&
      data.filter((suggestion) =>
        suggestion.toLowerCase().includes(userInput.toLowerCase())
      );

    this.setState(
      {
        activeSuggestion: 0,
        filteredSuggestions: filteredSuggestions,
        showSuggestions: true,
        userInput,
      },
      () => this.props.handleChange(this.state)
    );

    if (userInput === "") {
      this.setState({
        filteredSuggestions: data,
      });
    }else {
      this.setState({
        filteredSuggestions
      });
    }
  };

  handleClick = (e) => {
    this.setState(
      {
        activeSuggestion: 0,
        filteredSuggestions: [],
        showSuggestions: false,
        userInput: e.currentTarget.innerText,
      },
      () => this.props.handleChange(this.state)
    );
  };

  onKeyDown = (e) => {
    const { activeSuggestion, filteredSuggestions } = this.state;
    if (e.keyCode === 13) {
      this.setState(
        {
          activeSuggestion: 0,
          showSuggestions: false,
        },
        async () => {
          await this.props.handleChange(this.state);
          await this.props._onSearchForDataPress(e);
        }
      );
    } else if (e.keyCode === 38) {
      if (activeSuggestion === 0) {
        return;
      }
      this.setState({ activeSuggestion: activeSuggestion - 1 });
    } else if (e.keyCode === 40) {
      if (activeSuggestion + 1 === filteredSuggestions.length) {
        return;
      }
      this.setState({ activeSuggestion: activeSuggestion + 1 });
    }
  };

  handleBtnClick = (e) => {
    e.preventDefault();
    Cookies.remove("location");
    if (!this.props.isDasboard) {
      Cookies.remove("allScanLocation");
      this.props.getOrders(1, true, false);
    } else {
      this.props.getOrders(true);
    }
  };

  handleFocus = () => {
    const { userInput } = this.state;

    this.setState({
      showSuggestions: true,
      filteredSuggestions: userInput
        ? this.props.data.filter((item) => item.toLowerCase().includes(userInput.toLowerCase()))
        : this.props.data,
    });
  };
  render() {
    const {
      showSuggestions,
      userInput,
      filteredSuggestions,
      activeSuggestion,
    } = this.state;
    const {
      data,
      label,
      placeholder,
      value,
      searchStatus,
      locationLoading,
    } = this.props;
    let suggestionsListComponent;

    if (showSuggestions) {
      if (filteredSuggestions.length) {
        suggestionsListComponent = (
          <ul className="suggestions">
            {filteredSuggestions.map((suggestion, index) => {
              let className;
              if (index === activeSuggestion) {
                className = "suggestion-active";
              }
              return (
                <li
                  className={className}
                  key={suggestion}
                  onClick={(e) => this.handleClick(e)}
                >
                  {suggestion}
                </li>
              );
            })}
          </ul>
        );
      } else {
        suggestionsListComponent = (
          <div className="suggestions">
            <ul>
              <li className="disabled">No suggestions available.</li>
            </ul>
          </div>
        );
      }
    }

    return (
      <div className="Main" ref={this.wrapperRef}>
        <div className="input-group">
          <div className="form-outline">
            <label>{label}</label>
            <Input
              type="text"
              className="AutoComplete custom_input" 
              placeholder={placeholder}
              onFocus={this.handleFocus}
              value={value}
              onChange={(e) => this.handleChange(e)}
              // onKeyDown={(e) => this.onKeyDown(e)}
            />
            {suggestionsListComponent}
          </div>
          {!locationLoading && searchStatus && userInput.trim() && (
            <button
              className="close_button main_close__search"
              onClick={this.handleBtnClick}
            >
              <i className="fa fa-close"></i>
            </button>
          )}
        </div>
      </div>
    );
  }
}

export default AutoComplete;
